// Mirrors the API's landline rule: the field is always optional, but when it is
// filled it must start and end with a digit, may use spaces or hyphens as
// separators (e.g. "011-23456789", "0120 4567890"), and carry 6 to 15 digits.
export function isValidLandline(landline) {
  const value = (landline ?? "").toString().trim();
  if (value.length === 0) {
    return true;
  }
  if (!/^[0-9]([0-9\s-]*[0-9])?$/.test(value)) {
    return false;
  }
  const digitCount = (value.match(/[0-9]/g) || []).length;
  return digitCount >= 6 && digitCount <= 15;
}

export default isValidLandline;
